import React from 'react'
import { APP_CONFIG } from '../data/constants.jsx'
import { useTranslation } from 'react-i18next'
import Logo from './ui/Logo'
import GetAppButton from './GetAppButton'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="mb-4">
              <Logo variant="lockupInverted" className="h-11 w-auto" />
            </div>
            <p className="opacity-70 leading-relaxed max-w-md">
              {t('footer.description')}
            </p>

            {/* The light skin: this column sits on the dark footer ground. */}
            <div className="mt-6">
              <p className="text-sm font-semibold mb-3">{t('app.downloadTitle')}</p>
              <GetAppButton variant="light" />
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 opacity-70">
              <p className="mb-2">সাহায্য, ডোনেশন, স্পন্সর, সাজেশন, বাগ, রিপোর্টসহ যে কোনো প্রয়োজনে যোগাযোগ করুন</p>
              <p>+880 1314-951751 (WhatsApp)</p>
              <p>+880 1703-788889 (WhatsApp)</p>
              <p>ঠিকানা: ঢাকা, বাংলাদেশ</p>
              <a href="https://www.linkedin.com/in/hijamibnaomar/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-100 transition-opacity mt-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                Contact the Project Architect
              </a>
              <div className="mt-4">
                <p className="mb-3 font-semibold opacity-100">{t('footer.socialMedia')}</p>

                {/* WhatsApp Group */}
                <a href="https://chat.whatsapp.com/IeIM02YOmDMIhPY62owC10?mode=wwc" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-100 transition-opacity mb-2 text-sm">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  {t('footer.whatsappGroup')}
                </a>

                {/* Facebook Group */}
                <a href="https://www.facebook.com/groups/fajrfighter" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-100 transition-opacity mb-2 text-sm">
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  {t('footer.facebookGroup')}
                </a>

                {/* Social Media Icons Row */}
                <div className="flex gap-4 mt-3">
                  <a href="https://www.linkedin.com/company/fajrfighter/" target="_blank" rel="noopener noreferrer" className="hover:opacity-100" title={t('footer.linkedinPage')}>
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  <a href="https://www.facebook.com/fajrfighterofficial/" target="_blank" rel="noopener noreferrer" className="hover:opacity-100" title={t('footer.facebookPage')}>
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2 text-sm">
              <a href="/user-guide" className="hover:opacity-100 transition-opacity">
                কিভাবে ব্যবহার করবেন
              </a>
              <a href="/privacy-policy" className="hover:opacity-100 transition-opacity">
                গোপনীয়তা নীতি
              </a>
              <a href="/terms-and-conditions" className="hover:opacity-100 transition-opacity">
                নিয়মাবলী ও শর্তাবলী
              </a>
            </div>
            <p className="text-sm">&copy; {new Date().getFullYear()} {APP_CONFIG.name}.com {t('footer.rights')}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer